import React from 'react';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const PRICING_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.ADD_PRICE_BUTTON,
        nextOnTargetClick: true,
        title: 'Pricing',
        placement: 'right',
        borderRadius: 12,
        content: (
            <>
                Travelity&#39;s pricing engine enables you to create flexible
                pricing options.
                <br />
                Now the product needs a price. Tap the button to add a price.
            </>
        ),
    },
    {
        className: OnboardingClasses.PER_PERSON_CARD,
        waitForTarget: true,
        title: 'Per Person Pricing',
        placement: 'right',
        borderRadius: 8,
        padding: 8,
        content: (
            <>
                One of the supported units of price can be a single
                person/customer.
                <br />
                Fill in the <b>Per Person</b> field to define the unit price.
                <br />
                If your product has a constant base price, which is computed
                once in the formula, then fill in the <b>Base</b> field as well.
            </>
        ),
    },
    {
        className: OnboardingClasses.INCLUSIONS,
        title: 'Inclusions',
        placement: 'right',
        borderRadius: 28,
        padding: 8,
        content: (
            <>
                You can type in anything that is included in the price. For
                example Wifi, 1 bottle of water, etc.
            </>
        ),
    },
    {
        className: OnboardingClasses.DEPENDENCIES,
        title: 'Dependencies',
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                The product&#39;s price can also depend on things like vehicle
                or boat of which capacity is used, or when in the year the
                product is served.
                <br />
                Lets leave this right now and proceed to press the checkmark
                icon.
            </>
        ),
    },
    {
        className: OnboardingClasses.PRICING_CARDS,
        title: 'Save Pricing',
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                Great, now you&#39;ve created your first pricing option.
                <br />
                Note that the pricing option, which doesn&#39;t have
                dependencies is the default option and is required to be set,
                even if you have other pricing options as well.
                <br />
                There can be only one pricing per dependency combination or its
                absence.
            </>
        ),
    },
    {
        className: OnboardingClasses.ADD_PRICE_BUTTON,
        waitForTarget: true,
        nextOnTargetClick: true,
        title: 'More Pricing Options',
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                Feel free to add more pricing options with the dependencies you
                like.
            </>
        ),
    },
    {
        className: OnboardingClasses.PAYMENT_METHODS,
        title: 'Payment Methods',
        placement: 'right',
        borderRadius: 24,
        content: <>Select all the payment methods your product accepts.</>,
    },
    {
        className: OnboardingClasses.PREPAYMENT,
        nextOnTargetClick: true,
        title: 'Prepayment',
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                Toggle and fill in the form if booking of this product requires
                prepayment (wherever applicable).
            </>
        ),
    },
];
